import styled from "styled-components"

export const ListBadge = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -3px;
  .badge {
    margin: 3px;
  }
`

export const ListPrice = styled.div`
  text-align: left;
`

export const ListItemPrice = styled.div`
  label {
    font-family: "Chakra Petch";
    color: #062c44;
    font-weight: 600;
  }
  + .list-item-price {
    margin-top: 10px;
  }
`

export const PriceRange = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -3px;
`

export const PriceItem = styled.div`
  position: relative;
  padding: 3px;
`

export const PriceBadge = styled.label`
  cursor: pointer;
  display: inline-flex;
  background: ${props => props.bg};
  border: 1px solid ${props => props.borderColor};
  color: ${props => props.color};
  font-weight: 500;
  border-radius: 6px;
  font-size: 12px;
  line-height: 20px;
  padding: 3px 6px;
  & input {
    display: none;
  }
  &:hover{
    background-color:transparent;
    border-color: #FF3E00;
    color: #FF3E00;
  }
`

export const TopBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -5px 20px -5px;
  @media (max-width: 991.98px) {
    margin: 0 0 10px;
    position: sticky;
    top: 70px;
    z-index: 99;
    background:#F4FBFF;
    padding:5px 0;
  }
`


export const TopLeftBar = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  padding:0 5px;
  @media (min-width: 992px) {
    display: none;
  }
`

export const Filter = styled.button`
  background-color:#FF3E00;
  color:#fff;
  border-radius:5px;
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 3px 6px;
  @media (min-width: 576px) {
    font-size: 16px;
    line-height: 20px;
    padding: 5px 12px;
  }
  .icon, .text {
    display:inline-flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:center;
  }
  .icon {
    height:20px;
    svg{
      width: 12px;
      height: 8px;
      fill:#fff;
    }
  }
  .text {
    + .icon {
      margin-left: 5px;
    }
  }
`

export const TopMiddleBar = styled.div`
  position: relative;
  padding: 0 5px;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
`

export const TopRightBar = styled.div`
  position: relative;
  border-left:1px solid #8CB7CE;
  padding: 0 5px 0 10px;
  display:none;
  @media (min-width: 576px) {
    display:inline-flex;
    padding: 0 5px 0 15px;
  }
`
